<template>
  <v-dialog v-model="dialog" persistent max-width="300px">
    <v-card grid-list-md>
      <ModelTitle title="New Term" @close="close()" />

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="Term.name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12">

            <!-- <v-select :loading="loading" item-value="id" item-text="name" v-model="Term.YearId" outlined
              :hide-details="yearErrors.length === 0" dense :error-messages="yearErrors" :items="years"
              label="Select Year">


            </v-select> -->

            <v-autocomplete dense :hide-details="yearErrors.length === 0" item-text="name" item-value="id" :loading="loading" v-model="Term.YearId"
              :items="years" clearable :error-messages="yearErrors" label="Select Year" outlined>
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="text--primary text-capitalize">
                    {{ item.name }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="caption" v-if="item.Class">
                    {{ item.Class.name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import termService from "../service.js";
import yearService from "@/modules/ReportCard/Year/service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-payee",
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  data() {
    return {
      years: [],
      loading: false,
      dialog: false,
      Term: {
        name: null,
        YearId: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Term: {
      name: {
        required,
      },
      YearId: {
        required,
      },
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getYear()
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Term.name.$dirty) return errors;
      if (!this.$v.Term.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    yearErrors() {
      const errors = [];
      if (!this.$v.Term.YearId.$dirty) return errors;
      if (!this.$v.Term.YearId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    getYear() {
      this.loading = true;
      yearService.getAll().then(response => {
        console.log('response', response)
        this.loading = false;
        this.years = response.data
        console.log('year', this.years)
      }).catch(error => {
        this.loading = false;
        console.log('error getting year', error)
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Term = {
        name: null,
      };
      this.$v.$reset();
    },
    submit() {
      console.log('submit', this.Term)
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return termService
          .create(this.Term)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Term is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            console.log('err', err)
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
